<template>
    <ThLink
        v-if="route"
        :to="route"
    >
        <ItemPlaceholder
            :index="index"
            :data="data"
            :is-final
        />
    </ThLink>

    <ItemPlaceholder
        v-else
        :index="index"
        :data="data"
        :is-final
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type {
    PlaceholderPersonalization,
    PlaceholderRing,
    PlaceholderStone,
} from '@/components/rings/ring-builder/RingBuilder.vue'
import { assertNever } from '@/helpers'
import type { ButtonRouteRelative } from '@/components/ui/buttons/useThButton'

import ThLink from '@/components/ui/buttons/ThLink.vue'
import ItemPlaceholder from '@/components/rings/ring-builder/item/ItemPlaceholder.vue'

type PlaceholderItem =
    | PlaceholderRing
    | PlaceholderStone
    | PlaceholderPersonalization

const props = defineProps<{
    index: number
    data: PlaceholderItem
    isFinal?: boolean
}>()

const route = computed((): ButtonRouteRelative | undefined => {
    const data = props.data

    switch (data.__typename) {
        case 'placeholder-ring':
        case 'placeholder-stone':
            return data.route
        case 'placeholder-personalization':
            return undefined
        default:
            return assertNever(data, undefined)
    }
})
</script>
